module.exports = __webpack_public_path__ + "static/media/Lato-HairlineItalic.a567f4a8.ttf";